import { render, staticRenderFns } from "./ItemsMercaderiaExcel.vue?vue&type=template&id=0fb8ab18&"
import script from "./ItemsMercaderiaExcel.vue?vue&type=script&lang=js&"
export * from "./ItemsMercaderiaExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports